import { QueryClient } from '@tanstack/react-query';

// Create a client with optimized defaults
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // Data is considered fresh for 2 minutes
            staleTime: 2 * 60 * 1000,
            // Data stays in cache for 5 minutes
            cacheTime: 5 * 60 * 1000,
            // Retry failed requests 2 times
            retry: 2,
            // Don't refetch on window focus by default (can be overridden per query)
            refetchOnWindowFocus: false,
            // Refetch on reconnect
            refetchOnReconnect: true,
        },
    },
});

export default queryClient;
